import LegalPage from "./LegalPage";

export default function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy"
      description="What the Cowork Cookbook collects and what it doesn't."
    >
      <p>
        The Cowork Cookbook is a public reference site. We do not collect or store any personal
        information from visitors.
      </p>
      <h2>What we do store</h2>
      <ul>
        <li>
          <strong>Star ratings</strong> are stored alongside an anonymous identifier derived from a
          one-way salted hash of your IP address and user agent. The salt rotates daily so the
          identifier is not stable across days. We use this only to throttle abuse.
        </li>
        <li>
          <strong>Theme preference</strong> and other UI state are stored in your browser&apos;s
          localStorage and never leave your device.
        </li>
        <li>
          <strong>Anonymous analytics</strong> (page views, search queries that returned no
          results, recipe downloads) are collected only after you grant consent. We honor the
          browser&apos;s Do-Not-Track and Global Privacy Control signals.
        </li>
      </ul>
      <h2>What we do not store</h2>
      <ul>
        <li>Names, email addresses, or any other personal identifier.</li>
        <li>The contents of your Cowork conversations.</li>
        <li>Anything you paste into a copy-to-clipboard prompt.</li>
      </ul>
      <h2>Cookies</h2>
      <p>
        We use localStorage (a small piece of browser storage) for the theme toggle and the
        consent state. We do not set HTTP cookies.
      </p>
      <h2>Contact</h2>
      <p>
        For privacy questions, file an issue against the{" "}
        <a href="https://github.com/seangalliher/CoworkCookBookWebApp/issues">web app repo</a>.
      </p>
    </LegalPage>
  );
}
